import {
  SET_QUOTES
} from '@actions/types';

const INITIAL_STATE = {
  quoteInfo: {
    richQuotes: [],
    otherQuotes: []
  }
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_QUOTES:
      return { ...state, quoteInfo: { ...action.payload }};
    default:
      return state;
  }
};
